import CustomerBirthDate  from "./CustomerBirthDate";
import CustomerBirthMonth from "./CustomerBirthMonth";
import CustomerBirthYear  from "./CustomerBirthYear";

class CustomerBirthday {
  constructor(
    private readonly _year: CustomerBirthYear = new CustomerBirthYear(),
    private readonly _month: CustomerBirthMonth = new CustomerBirthMonth(),
    private readonly _date: CustomerBirthDate = new CustomerBirthDate(),
  ) {
  }

  get year() {
    return this._year;
  }

  get month() {
    return this._month;
  }

  get date() {
    return this._date;
  }
}

export default CustomerBirthday;
